import {useOutletContext} from "react-router-dom";

import SBEditable from "../../../components/sbEditable/sbEditable";
import ListingHeader from "../../../components/listingHeader/listingHeader";
import styles from "./articleListingByArticleTypeWidget.module.scss";
import ArticleAsideCard from "../../../components/articleAsideCard/ArticleAsideCard";
import {useStoryblokArticlesByArticleTypeWidget} from "../../../hooks/useStoryblokArticlesByArticleTypeWidget";
import {FormattedMessage} from "react-intl";

export default function ArticleListingByArticleTypeWidget({blok}) {
  const {story} = useOutletContext();
  const articleType = story?.content.article_type.content.article_type;
  const [articles, isLoading] =
    useStoryblokArticlesByArticleTypeWidget(articleType);

  if (!isLoading && articles.length === 0) {
    return null;
  }

  return (
    <SBEditable blok={blok}>
      <ListingHeader>
        <h3>
          <FormattedMessage id="component.article_listing_by_cateogry_widget.headline" />
        </h3>
      </ListingHeader>
      <ul className={styles.wrapper}>
        {isLoading ? <div className="loader centered" /> : null}
        {articles.slice(0, 3).map((a, idx) => {
          return (
            <li key={a.uuid}>
              <ArticleAsideCard
                slug={a.slug}
                thumbnail={a.content.thumbnail}
                authors={a.content.authors}
                title={a.content.headline}
                date={a.content.created_at}
                article_type={a.content.article_type}
                comment_count={5}
                enable_comments={a.content.has_comments}
                enable_social_sharing={a.content.has_social_sharing}
                use_legacy_thumbnail_background={
                  a.content.legacy_thumbnail_background
                }
              />
              {idx < articles.length - 1 ? <hr /> : null}
            </li>
          );
        })}
      </ul>
    </SBEditable>
  );
}
